import React, { Component } from 'react';
import { FormGroup,  FormFeedback, Input, Row, Col,Label} from 'reactstrap';

import * as Validations from '../validation/validations';
import * as FormLogic from './FormLogic'
import { run, validationRunner } from '../validation/validationRunner'

const fieldValidations = [
  validationRunner("IBAN", "IBAN", Validations.IBAN),
  validationRunner("Ascription", "Tenaamstelling", Validations.requiredIBAN, Validations.maxLength(255)),
]

class RegistrationFormFinancialData extends Component {
  constructor(props) {
    super(props);
    this.validate = false;
    this.state = {
      validationErrors: [],
      fieldsTouched: [],

      IBAN: "",
      Ascription: "",
    };

    this.handleChange = FormLogic.handleChange.bind(this);
    this.errorFor = FormLogic.errorFor.bind(this);
    this.checkInvalid = FormLogic.checkInvalid.bind(this);
    this.setFieldsTouched = FormLogic.setFieldsTouched.bind(this);
    this.handleChangeToUpper = FormLogic.handleChangeToUpper.bind(this);

    this.run = run.bind(this);
  }

  componentDidUpdate() {
    this.runValidations();
  }

  runValidations(ignoreTouched) {
    if (ignoreTouched) {
      this.validate = true;
    }
    return this.run(fieldValidations);
  }

  getFormValues() {
    return {
      "IBAN" : this.state.IBAN,
      "Ascription" : this.state.Ascription
    }
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={{size:3, offset:1}} />
          <Col md={7}>
            <h2>
              Bankgegevens
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="FormDescription" md={{size:10, offset:1}} >
            De vereniging zal periodiek een contributiebedrag in rekening brengen. Voor het innen van de contributie hebben we een IBAN nummer nodig.
          </Col>
        </Row>

        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label">Rekeningnummer (IBAN)</Label>
          </Col>
          <Col md={7}>
            <Input
              name="IBAN"
              autoComplete="ignored-123456"
              value={this.state.IBAN}
              onChange={this.handleChangeToUpper}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("IBAN")}
              innerRef={(input) => { this.IBAN = input; }}
              className="Input" />
            <FormFeedback>{this.errorFor("IBAN")}</FormFeedback>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col md={{size:3, offset:1}} >
            <Label className="Label"  >Tenaamstelling </Label>
          </Col>
          <Col md={7}>
            <Input
              name="Ascription"
              autoComplete="ignored-123456"
              value={this.state.Ascription}
              innerRef={(input) => { this.Ascription = input; }}
              onChange={this.handleChange}
              onBlur={this.setFieldsTouched}
              invalid={this.checkInvalid("Ascription")}
              className="Input"  />
            <FormFeedback>{this.errorFor("Ascription")}</FormFeedback>
          </Col>
        </FormGroup>
      </div>
    );
  }
}
export default RegistrationFormFinancialData



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationFormFinancialData.jsx